import { api } from "@api/api";
import { BookMonth } from "@modules/bookMonths/types";
import { BookMonthFormValues } from "@modules/bookMonths/validations";

export async function editBookMonthService(id: string, data: Partial<BookMonthFormValues>): Promise<BookMonth> {
  const { data: bookMonth } = await api.patch<BookMonth>(`v2/bookstore/book_month_admin/${id}/`, data);
  return bookMonth;
}
